module.exports = __webpack_public_path__ + "img/logo.816e6696.png";